import axios from "axios";
import _get from "lodash/get";

import Config from "../config";
import ERROR_MESSAGES from "../constants/errorMessages";

const instance = axios.create({
  timeout: 15000,
  timeoutErrorMessage: "Transaction timeout.\n(Error code: 200504)",
});
instance.defaults.baseURL = Config.baseStakeApiUrl;
instance.defaults.headers = {
  "Access-Control-Allow-Origin": "*",
  "Content-Type": "application/json",
};

instance.interceptors.response.use(
  response => {
    return _get(response, "data.result", {});
  },
  error => {
    let e = _get(error, "response.data", {});
    if ("string" === typeof e) {
      e = {};
    }
    const msg = ERROR_MESSAGES[e.error_code];
    e.message = msg || _get(e, "message", error.message);
    return Promise.reject(e);
  }
);

export default instance;
